/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable import/extensions */
/* eslint-disable react/no-array-index-key */
/* eslint-disable object-curly-newline */
/* eslint-disable camelcase */
import React, { useMemo, useContext } from 'react'
import { useLocation } from 'react-router'
import { useSelector } from 'react-redux'
import { APPLICATION_STATE, ApplicationContext } from '@apps/contexts/ApplicationContext'
import { setPageAnalytics } from '@apps/utils/Analytics'
import { ANALYTICS_EVENT_TYPES } from '@apps/utils/constants'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { getById, getByTitle } from '@apps/utils/contentful'
import { Image } from '@telus/koodo-ui-kit'
import useTagManagerInfo from '../../../_engine/hooks/useTagManagerInfo'
import Heading4 from '@/apps/components/Typography/Heading4'
import BodyMedium from '@/apps/components/Typography/BodyMedium'

const processStrikethroughText = (text) => {
  const regex = /~(.*?)~/g

  const parts = text.split(regex)

  return parts.map((part, index) => {
    if (index % 2 === 1) {
      return <del key={index}>{part}</del>
    }

    return <React.Fragment key={index}>{part}</React.Fragment>
  })
}

const Accordion = ({
  title, subtitle, children, open, setOpen, onInfoClick, testId
}) => {
  const location = useLocation()
  const {
    [APPLICATION_STATE.CURRENT_LANGUAGE]: language,
    [APPLICATION_STATE.CURRENT_REGION]: region
  } = useContext(ApplicationContext)

  const { pageContent } = useSelector((state) => state.common.content)
  const tagManagerInfo = useTagManagerInfo()

  const pushClickAnalytics = ({ click_text, journey_type, event_type, event_click = ANALYTICS_EVENT_TYPES.CLICK } = {}) => {
    const analyticsInfo = {
      ...tagManagerInfo,
      click_text,
      journey_type
    }

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(
      setPageAnalytics(location, 'click', region, language, analyticsInfo, event_type, event_click)
    )
  }

  const haveSimPage = getById(pageContent, 'haveSimPage')
  const localizedHaveSimPage = haveSimPage?.[language]
  const { images } = localizedHaveSimPage || []

  const assets = useMemo(() => {
    if (!images?.length) return {}

    const info = getByTitle(images, 'info-icon')
    const chev = getByTitle(images, 'chevron-right')
    const chevCol = getByTitle(images, 'chevron-right-colored')

    return {
      infoIcon: info?.url,
      infoIconAlt: info?.title,
      chevronRight: chev?.url,
      chevronRightColored: chevCol?.url
    }
  }, [images])

  const handleInfoClick = (e) => {
    e.stopPropagation()
    if (title?.includes('eSIM')) {
      pushClickAnalytics({ click_text: `${title} - Info Icon`, journey_type: 'eSIM', event_type: 'eSIM learn more info is clicked' })
    } else {
      pushClickAnalytics({ click_text: `${title} - Info Icon`, journey_type: 'pSIM', event_type: 'pSIM learn more info is clicked' })
    }
    onInfoClick()
  }

  const handleAccordionToggle = () => {
    if (title?.includes('eSIM')) {
      pushClickAnalytics({ click_text: `${title} - ${open ? 'Close' : 'Open'} Accordion`, journey_type: 'eSIM', event_type: 'eSIM is selected' })
    } else {
      pushClickAnalytics({ click_text: `${title} - ${open ? 'Close' : 'Open'} Accordion`, journey_type: 'pSIM', event_type: 'pSIM is selected' })
    }
    setOpen()
  }

  return (
    <div
      className="py-5 pl-4 pr-4 sm:pl-8 sm:pr-8 border border-silver mt-2.5"
      data-testid={testId}
    >
      <button type="button" className="block w-full" onClick={handleAccordionToggle} data-testid={`${testId}-toggle`}>
        <div className="flex justify-between w-full">
          <div className="flex">
            <div className="mr-3 pt-0.5">
              <Image
                alt="click here"
                src={open ? assets?.chevronRightColored : assets?.chevronRight}
                className={`transform origin-center transition duration-200 ease-out ${open && 'rotate-90'
                  }`}
              />
            </div>
            <div>
              <Heading4 className="text-medium font-h3 leading-6 text-left">
                {processStrikethroughText(title)}
              </Heading4>
              <BodyMedium className="leading-6 pt-1 text-left">{subtitle}</BodyMedium>
            </div>
          </div>
          <div
            role="button"
            tabIndex={0}
            className="z-10 w-7 min-w-min"
            onClick={handleInfoClick}
            onKeyDown={handleInfoClick}
            data-testid={`${testId}-info-button`}
          >
            <Image
              width={28}
              alt={assets?.infoIconAlt}
              src={assets?.infoIcon}
            />
          </div>
        </div>
      </button>
      <div
        className={classNames(
          'grid overflow-hidden transition-all duration-300 ease-in-out text-black',
          open
            ? 'grid-rows-animate-height-open opacity-100'
            : 'grid-rows-animate-height-closed opacity-0'
        )}
      >
        <div className="overflow-hidden">{children}</div>
      </div>
    </div>
  )
}

Accordion.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  onInfoClick: PropTypes.func.isRequired,
  testId: PropTypes.string
}

export default Accordion
